// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"e2a6f36f","453":"68693753"}[chunkId] + ".chunk.js";
};